// VIS-267: one heavy graphics step at a time once the map is live. An iPhone 13 Pro lost its graphics ~40 s after Ready
// as a season switch loaded the tree kit's pictures (parsed copies, the transcoder's heaps, new texture arrays: Sentry
// MAPMYSTAY-VIEWER-Z), and another while the light-casting maps were rebuilt (a new light map at dusk, the height map
// after a switch: MAPMYSTAY-VIEWER-19). Each fits; their peaks on top of each other did not. A step that loads or
// allocates a lot waits its turn and holds the lane while it runs (`const end = await lane.turn(name)`, end() when done:
// lazy/kittrees.js a season's pictures, trees.js the forest colour's bake passes); a step that runs inside a frame and
// can wait a few frames asks busy() first (lazy/lightcast.js a full or partial redraw: the light shows a moment later,
// as it would on a slower phone). Under the start cover (live false) the opening orders its own steps (main.js smooth
// start), so nothing waits there and turn() resolves at once.
const held = new Map(); // name -> count
const waiting = []; // resolvers of turn() calls waiting for the lane
function wakeNext() { while (waiting.length && !lane.busy()) waiting.shift()(); }
export const lane = {
  live: false, // main.js goLive: from the cover's lift on
  /** a heavy step starts now; the returned function ends it (once) */
  begin(name) {
    held.set(name, (held.get(name) || 0) + 1);
    let done = false;
    return () => {
      if (done) return;
      done = true;
      const n = held.get(name) - 1;
      if (n > 0) held.set(name, n); else held.delete(name);
      wakeNext();
    };
  },
  /** a heavy step waits until no other runs (live only), then holds the lane: resolves its end function */
  turn(name) {
    if (!lane.busy()) return Promise.resolve(lane.begin(name));
    return new Promise((r) => waiting.push(r)).then(() => lane.turn(name)); // (another may have taken it first)
  },
  /** a heavy step is running (and the map is live): a step that can wait does */
  busy: () => lane.live && held.size > 0,
  /** QA: the steps running now, and how many wait */
  info: () => ({ held: [...held.keys()], waiting: waiting.length }),
};
